import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-block-tables-modal',
  template: require('./block-tables-modal.component.html'),
  styles: [require('./block-tables-modal.component.scss')],
})

export class BlockTablesModalComponent implements OnInit {
  public startDate: Date;
  public endDate: Date;
  public minDate: Date;
  public invalid: boolean;

  private dates = {
    start: null,
    end: null,
  };

  constructor(@Inject('$scope') public scope) {
  }

  ngOnInit() {
    this.setMinDate();
  }

  public onConfirm() {
    if (this.scope.isBlock && (!this.dates.start || !this.dates.end)) {
      this.invalid = true;
      return;
    }

    this.scope.$parent.onConfirm(this.dates);
  }

  public onCancel() {
    this.scope.$parent.onCancel();
  }

  public onInputValidated(invalid: boolean): void {
    this.invalid = invalid;
  }

  public onStartDateChange(date: Date): void {
    this.dates.start = date;
  }

  public onEndDateChange(date: Date): void {
    this.dates.end = date;
  }

  private setMinDate(): void {
    this.minDate = new Date();
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/areas/block-tables-modal/block-tables-modal.component.ts